/**
 * Answers feature service layer — API, query streaming, filters, citations, documents.
 *
 * UI hooks and components should import from here rather than calling RAG HTTP directly.
 */

import { AnswersEndpoints, answersFetch, answersFetchJson } from './answersApiClient';
import * as citationService from './answersCitationService';
import * as conversationService from './answersConversationService';
import * as documentService from './answersDocumentService';
import * as filterService from './answersFilterService';
import * as presentationService from './answersPresentationService';
import * as queryService from './answersQueryService';
import * as sourceService from './answersSourceService';

export { AnswersEndpoints, answersFetch, answersFetchJson };

export {
  getFilterOptions,
  clearFilterOptionsCache,
  getFilterMatchCount,
} from './answersFilterService';

export { executeRagQuery } from './answersQueryService';

export { resolveCitation } from './answersCitationService';

export { makeEmptyTurn, buildConversationHistory } from './answersConversationService';

export {
  normalizeHyphensForPath,
  normalizeSerffId,
  normalizeDocHint,
  getRagOrigin,
  sourceDocKey,
  getPdfUrlString,
  fileNameOnly,
} from './answersDocumentService';

export {
  formatResponseSeconds,
  formatFilterStatsLine,
  scorePercentForTurn,
  isNoInformationAnswer,
} from './answersPresentationService';

export { findSourceIndex } from './answersSourceService';

/** Facade for dependency injection and testing. */
export const answersService = {
  endpoints: AnswersEndpoints,
  filters: {
    getOptions: filterService.getFilterOptions,
    clearOptionsCache: filterService.clearFilterOptionsCache,
    getMatchCount: filterService.getFilterMatchCount,
  },
  query: {
    execute: queryService.executeRagQuery,
  },
  citations: {
    resolve: citationService.resolveCitation,
  },
  conversation: {
    makeEmptyTurn: conversationService.makeEmptyTurn,
    buildHistory: conversationService.buildConversationHistory,
  },
  documents: {
    getPdfUrl: documentService.getPdfUrlString,
    sourceDocKey: documentService.sourceDocKey,
    fileNameOnly: documentService.fileNameOnly,
  },
  presentation: {
    formatResponseSeconds: presentationService.formatResponseSeconds,
    formatFilterStatsLine: presentationService.formatFilterStatsLine,
    scorePercentForTurn: presentationService.scorePercentForTurn,
    isNoInformationAnswer: presentationService.isNoInformationAnswer,
  },
  sources: {
    findIndex: sourceService.findSourceIndex,
  },
};
